<template>
  <div class="menu-page">
    <div>
      <dashboard-nav></dashboard-nav>
      <div class="d-flex bodyWrapper">
        <div class="nav-view">
          <main-nav></main-nav>
        </div>

        <!-- VIEW START -->
        <div class="main-view" v-if="dataReady">
          <breadcrumb :crumb="name"></breadcrumb>
          <div class="intro-wrapper main-x-spacing">
            <h2>{{ title }}</h2>
            <v-row>
              <v-col cols="8">
                <v-text-field
                  v-model="searchQuery"
                  prepend-inner-icon="search"
                  label="Search Categories"
                  class="toWhite"
                  flat
                  hide-details
                  single-line
                  solo
                ></v-text-field>
              </v-col>
              <v-col cols="2" v-if="userType > 8">
                <v-btn
                  :ripple="false"
                  @click="openAddCategory"
                  depressed
                  style="min-width: 100px; max-width: 100%"
                  class="gen-button white--text flex-grow-1 flex-shrink-0"
                  color="#60a45f"
                >
                  <v-icon>add</v-icon>
                  <span>Add New Category</span>
                </v-btn>
              </v-col>
              <!-- <v-col cols="2">
                <v-btn
                  :ripple="false"
                  @click="uploadMenu"
                  depressed
                  class="gen-button"
                >
                  <v-icon>backup</v-icon>
                  <span>Upload Menus</span>
                </v-btn>
              </v-col> -->
            </v-row>
          </div>
          <!-- main view -->
          <div class="main-body-content main-x-spacing">
            <v-row>
              <!-- {{ getAllmenu }} -->
              <v-col cols="10">
                <div class="table-menu">
                  <v-data-table
                    :headers="headers"
                    :items="filteredSearchResult"
                    item-key="id"
                    class="elevation-0 dataTableUI staffTable border-me-light"
                  >
                    <!-- For Image -->
                    <template v-slot:item.image="{ item }">
                      <v-img
                        :src="item.image || require('@/assets/imgUpload.jpg')"
                        height="50px"
                        width="50px"
                        style="margin: 0 auto"
                      ></v-img>
                    </template>

                    <!-- For Names -->
                    <template v-slot:item.name="{ item }">
                      {{ item.name }}
                    </template>

                    <!-- For Actions -->
                    <template v-slot:item.action="{ item }" v-if="userType > 8">
                      <v-btn
                        :ripple="false"
                        x-small
                        text
                        class="white py-4 btn-outlined"
                        @click="openAddCategory('editMode', item)"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </div>
              </v-col>
              <v-col cols="2" class="col-2-side-tab col-2-side-tab-right">
                <div class="col-2-side-tab-wrapper max-height">
                  <div
                    class="switch-tab no-bg"
                    :class="{ activeSwitchTab: filterDataBy == '' }"
                  >
                    <v-btn
                      :ripple="false"
                      text
                      depressed
                      width="100%"
                      left
                      class="justify-start transparent switch-tab gen-button no-Btn-bg"
                      @click="
                        filterDataBy = '';
                        currentSwitchTab = '';
                      "
                    >
                      <div class="">
                        <strong>All Categories</strong>
                      </div>
                    </v-btn>
                  </div>
                  <div
                    v-for="(cat, index) in categories"
                    :key="index"
                    :class="{ activeSwitchTab: cat.id == currentSwitchTab }"
                    class="switch-tab"
                  >
                    <v-btn
                      :ripple="false"
                      text
                      depressed
                      width="100%"
                      left
                      class="justify-start transparent switch-tab gen-button no-Btn-bg"
                      @click="
                        filterDataBy = cat.id;
                        $forceUpdate();
                        currentSwitchTab = cat.id;
                      "
                    >
                      {{ cat.name }}
                    </v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
          <!-- Upload List -->
          <v-row justify="center" class="openDialogWrapper">
            <v-dialog
              v-model="openDialog"
              fullscreen
              max-width="50%"
              transition="scroll-x-reverse-transition"
              class="openDialog"
            >
              <v-card
                max-width="50%"
                tile
                class="ml-auto dialogCard"
                height="100%"
              >
                <!-- Add New Categories -->
                <div v-if="addNewCategoryActive" class="formLayerCard">
                  <h2 class="dialog-form-title">Add Categories</h2>
                  <v-form ref="dialogForm" class="dialog-form">
                    <v-row v-if="addNewCategoryActive && !editMode">
                      <v-col
                        style="position: relative"
                        cols="6"
                        v-for="(category, index) in newCategories"
                        :key="index"
                      >
                        <span class="removeItem" @click="removeItem(index)">
                          <v-icon color="red" size="14">cancel</v-icon>
                        </span>
                        <v-text-field
                          v-model="newCategories[index].name"
                          outlined
                          hide-details
                          label="Category Name"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" class="d-flex align-center pl-0">
                        <v-btn class="ml-3 error btn-add-more" @click="addMore">
                          <v-icon>mdi-plus</v-icon>
                          Add more
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-if="addNewCategoryActive && editMode">
                      <v-col style="position: relative" cols="12">
                        <v-text-field
                          v-model="editedCategoryData.name"
                          outlined
                          hide-details
                          label="Category Name"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>

                  <div class="dialogAction text-right">
                    <v-btn
                      :ripple="false"
                      @click="openDialog = false"
                      class="grey--text mr-3"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      v-if="addNewCategoryActive && !editMode"
                      :loading="loader"
                      :ripple="false"
                      color="#468346"
                      class="white--text"
                      @click="addNewCategory"
                      >Ok</v-btn
                    >
                    <v-btn
                      v-if="addNewCategoryActive && editMode"
                      :loading="loader"
                      :ripple="false"
                      color="#468346"
                      class="white--text"
                      @click="editCategory"
                      >Save</v-btn
                    >
                  </div>
                </div>

                <div v-if="bulkUploadMenuActive" class="formLayerCard">
                  <h2 class="dialog-form-title">Menu Bulk Upload</h2>
                  <v-form ref="dialogForm" class="dialog-form">
                    <p class="text-center">
                      <b>
                        Please select the CSV/EXcel file you want to batch
                        upload.
                      </b>
                    </p>
                    <vue-dropzone
                      ref="myVueDropzone"
                      id="dropzone"
                      :options="dropzoneOptions"
                    ></vue-dropzone>

                    <p style="margin-top: 100px" class="text-center">
                      Please download a sample file that shows how your list
                      should be created
                      <v-btn class="mt-10">
                        <v-icon>get_app</v-icon>
                        <span class="text-capitalize">
                          Download Sample File
                        </span>
                      </v-btn>
                    </p>
                  </v-form>
                  <div class="dialogAction text-right">
                    <v-btn
                      @click="
                        openDialog = false;
                        bulkUploadStaffActive = false;
                      "
                      class="grey--text mr-3"
                    >
                      Close
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </v-row>
        </div>
        <inner-page-loader v-else class="main-view"></inner-page-loader>
      </div>
    </div>
  </div>
</template>

<script>
import dashboard_Nav from "@/components/dashboard-nav";
import main_Nav from "@/components/mainNav";
import bread_crumb from "@/components/breadcrumb";
import inner_page_loader from "@/components/innerPageLoader";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapState } from "vuex";

import axios from "axios";

export default {
  data() {
    return {
      title: "Categories",
      dataReady: false,
      loader: false,
      editMode: false,
      editedCategoryData: {},
      name: "",
      openDialog: false,
      bulkUploadMenuActive: false,
      currentSwitchTab: "",
      filterDataBy: "",
      headers: [
        {
          text: "Category Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
          value: "action",
        },
      ],
      newCategories: [{ name: "" }, { name: "" }],
      addNewCategoryActive: false,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        addRemoveLinks: false,
        acceptedFiles: ".jpg, .jpeg, .png",
        dictDefaultMessage: `<p class=''><i class='fa fa-cloud-upload fa-4x'></i><br> Drag and drop a file here or Click to select a file</p>`,
      },
      rules: {
        required: (value) => !!value || "Required",
        number: (value) => !value || /^[0-9]*$/.test(value) || "Invalid value",
      },
      searchQuery: "",
    };
  },
  methods: {
    openAddCategory(edit, data) {
      if (edit == "editMode") {
        this.editMode = true;

        // Store the category being edited
        this.editedCategoryData = data;

        this.addNewCategoryActive = true;
        this.openDialog = true;
      } else {
        this.addNewCategoryActive = true;
        this.openDialog = true;
      }
    },
    addNewCategory() {
      if (this.$refs.dialogForm.validate()) {
        this.loader = true;

        this.$store
          .dispatch("addNewCategory", { data: this.newCategories })
          .then(() => {
            // Refresh categories
            this.$store.dispatch("getAllCategories");
            this.loader = false;

            // Close Modals
            this.addNewCategoryActive = false;
            this.openDialog = false;

            // Reset categories form
            this.newCategories = [{ name: "" }, { name: "" }];
          });
      }
    },
    editCategory() {
      if (this.$refs.dialogForm.validate()) {
        this.loader = true;

        // this.editedCategoryData.brandName = this.editedCategoryData.name;
        // delete this.editedCategoryData.name;

        axios
          .put(
            "/api/v1/category/" + this.editedCategoryData.id,
            { name: this.editedCategoryData.name },
            {
              headers: { Authorization: this.$store.state.token },
            }
          )
          .then(() => {
            // Refresh categories
            this.$store.dispatch("getAllCategories");
            this.loader = false;

            // Close Modals
            this.addNewCategoryActive = false;
            this.openDialog = false;
          })
          .catch(() => {
            // Close Modals
            this.addNewCategoryActive = false;
            this.openDialog = false;
          });
      }
    },
    removeItem(index) {
      if (this.newCategories.length > 1) {
        this.newCategories.splice(index, 1);
      }
    },
    addMore() {
      this.newCategories.push({ name: "" });
    },
    uploadMenu() {
      this.bulkUploadMenuActive = true;
      this.openDialog = true;
    },
    addNewMenu() {
      this.$router.push("/menus/item-details");
    },
  },
  watch: {
    categories(val) {
      if (val) {
        // stop page loader when data is ready
        this.dataReady = true;
      }
    },
    openDialog(val) {
      if (val == false) {
        // If openDialog is ever false, make editMode false
        this.editMode = false;
      }
    },
  },
  created() {
    this.$store.dispatch("getAllMenu");
    this.$store.dispatch("getAllCategories");
  },
  computed: {
    filteredSearchResult() {
      let grabArr = this.categories;
      const filterDataBy = this.filterDataBy;

      if (filterDataBy) {
        grabArr = grabArr.filter((cat) => cat.id == filterDataBy);
      }

      return grabArr.filter((item) => {
        if (
          item.name.toLowerCase().indexOf(this.searchQuery.toLowerCase()) !== -1 // search by name
        ) {
          return item;
        }
      });
    },
    ...mapState(["mainNav", "categories", "userType"]),
  },
  components: {
    "dashboard-nav": dashboard_Nav,
    "main-nav": main_Nav,
    vueDropzone: vue2Dropzone,
    breadcrumb: bread_crumb,
    "inner-page-loader": inner_page_loader,
  },
};
</script>

<style scoped>
.table-menu {
  width: 96%;
  margin-left: 2%;
  margin-right: 2%;
}
.table-menu .table-col2 {
  width: 40%;
}

.image {
  width: 130px;
}

.item_status_icon {
  color: green;
}
</style>
